import React from 'react';
import image from '../images/s_text_image.png';
import style from '../css/Component2.module.css';

function Three() {
	return (
		<div className={style.container}>
			<div className={style.box}>
				<h1 className={style.header}>Communication is essential!</h1>
				<p className={style.desc}>
					Clear, consistent communication drives success. We prioritize open
					dialogue, ensuring alignment with your needs and seamless
					collaboration throughout every repair.
				</p>
				<p className={style.desc}>
					we specialize in providing fast, reliable, and affordable home
					appliance repair services in Bangalore & Dhanbad. From washing
					machines to air conditioners, our expert technicians work diligently
					to restore your appliances to optimal performance with minimal
					downtime. HomeTech Repairs – Bringing Life Back to Your Appliances.
				</p>
			</div>

			<img src={image} alt="" className={style.image} />
		</div>
	);
}

export default Three;
